import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Pass Scans</Typography>
      <p>This table shows a history of all the scans you've done on this
        pass using Smasrtix Scan app or transactons you've done manually in
        Studio.
      </p>

      <p>Click the scan location field to view a map showing the location the scan was done. 
        This can be used to verify that scanner users are not scannig passes away from the
        expected venue. 
      </p>
   </div>
  )
}

export default HelpText